import {FloatingPortal} from '@/components/main/common';
import {useScrollTop} from '@/components/main/common/hooks/useScrollTop';
import {useLocation} from 'react-router-dom';

const PATHS_TO_HIDE_TOP_BUTTON = ['/'];

const TopButton = () => {
  const {isDisplay, scrollToTop} = useScrollTop();
  const {pathname} = useLocation();
  const shouldHideTopButton = PATHS_TO_HIDE_TOP_BUTTON.includes(pathname);

  if (shouldHideTopButton) return null;

  return (
    <FloatingPortal className={'floating_btns'} target={'soop_wrap'}>
      <button
        type='button'
        className={`page_top ${isDisplay ? 'active' : ''}`}
        onClick={scrollToTop}>
        상단 바로가기
      </button>
    </FloatingPortal>
  );
};

export default TopButton;
